import Api from './Api.ts';

// Get all support requests with pagination
export const getSupportRequests = async (page = 1, limit = 10) => {
  try {
    const response = await Api.get(`/support/admin/tickets?page=${page}&limit=${limit}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching support requests:', error);
    throw error;
  }
};

export const updateSupportRequest = async (id, data) => {
    try {
      const response = await Api.post(`/support/admin/tickets/${id}/reply`, data);
      return response.data;
    } catch (error) {
      console.error(`Error updating support request #${id}:`, error);
      throw error;
    }
  };


  export const markMessagesAsRead = async (id) => {
    try {
      const response = await Api.patch(
        `/support/admin/tickets/${id}/read`
      );
      return response.data;
    } catch (error) {
      console.error(`Error marking messages as read in support request #${id}:`, error);
      throw error;
    }
  };

  export const closeSupportRequest = async (id) => {
    try {
      const response = await Api.patch(`/support/admin/tickets/${id}/close`);
      return response.data;
    } catch (error) {
      console.error(`Error closing support request #${id}:`, error);
      throw error;
    }
  };